<template>
  <div>
    <div class="flex flex-wrap items-center justify-end">   
        <div class="mb-5 mr-4" v-if="!showBannerForm">
            <label>Duration (Sec)</label>
            <vs-input-number class="inputx" min="1"
                v-model="BrandingJson.eventBannersDuration" />
        </div>             
      <vs-button class="mb-2" v-if="!showBannerForm" @click="addNewBanner()">Add New</vs-button>
      <vs-button class="mb-2" icon="arrow_left" v-if="showBannerForm" @click="showBannerForm = false;bIndex = null;$emit('showSubmitButton',true);">Back To List</vs-button>
    </div>
    <vs-table v-if="!showBannerForm" :data="BrandingJson.eventBanners"> 
      <template slot="thead">
        <vs-th>BANNER</vs-th>
        <vs-th>TARGET TYPE</vs-th>
        <vs-th>DEEPLINK SECTION</vs-th>
        <vs-th>DEEPLINK TARGET</vs-th>
        <vs-th>ACTION</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td><img :src="tr['640x88']" class="avatar-border-2" width="200" /></vs-td>       
          <vs-td>{{tr.ExternalLink}}</vs-td>       
          <vs-td>{{tr.InternalLink}}</vs-td>       
          <vs-td>{{tr.TargetLink}}</vs-td>       
          <vs-td>
            <feather-icon
              icon="Edit3Icon"
              title="Edit"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"      
              @click="editBanner(indextr)"                
            />                    
            <feather-icon
              v-if="BrandingJson.eventBanners.length > 1"
              icon="TrashIcon"
              title="Delete"
              :svgClasses="['h-6 w-6 mr-4 cursor-pointer']"    
              @click="BrandingJson.eventBanners.splice(indextr,1);"                  
            ></feather-icon>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="vx-row" v-if="showBannerForm && bIndex >= 0 && data_local">
        <div class="vx-col md:w-1/1 w-full mt-5">
            <h4 class="mb-3">Banner Image</h4>
            <p>
                You need to upload all images or go for all images as set
            </p>
        </div>
        <!-- <div class="vx-col md:w-1/2 w-full mt-5">
            <label>Default Banner</label>
            <vs-switch :disabled="BrandingJson.eventBanners[bIndex].IsDefault" v-model="BrandingJson.eventBanners[bIndex].IsDefault" @change="setDefaultBanner()" />

        </div> -->
        <div class="vx-col md:w-1/2 w-full mt-3">
            <label>Target Link: </label>
            <div class="default-theme-wrapper ml-3">
                <div class="radio-wrapper mt-3">
                    <vs-radio class="mr-2" v-model="data_local.TargetLink" vs-value="NoLink" @input="checkLink('NoLink')">No Link</vs-radio>
                    <vs-radio class="mr-2" v-model="data_local.TargetLink" vs-value="External" @input="checkLink('External')">External Link
                    </vs-radio>
                    <vs-radio class="mr-2" v-model="data_local.TargetLink" vs-value="Internal" @input="checkLink('Internal')">Internal Link
                    </vs-radio>
                </div>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
            <div v-if="data_local.TargetLink=='External'">
                <label>URL / Link</label>
                <vs-input class="w-full" v-model="data_local.ExternalLink" />
            </div>
            <div v-if="data_local.TargetLink=='Internal'">
                <label>Choose a section</label>
                <v-select class="w-full select-large" v-model="data_local.InternalLink"
                    :options="landingURLOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full banner-single-wrap">
            <p class="device-name">
                <strong>
                    iPhone 5
                    <span>*</span>
                </strong>
            </p>
            <div class="event-icon-upload custom-brandingbanner-wrap">
                <div class="single-banner">
                    <img v-if="data_local['640x88']" :src="data_local['640x88']" />
                    <!-- <span class="img-delete-butn">
                        <button @click="
                              deleteBrandingJson($event, '640x88', 'eventBanners', bIndex)
                            ">
                            <img src="../../assets/images/btn-del.png" />
                        </button>
                    </span> -->
                </div>
                <div class="choose-file-area">
                    <input type="file" @change="
                            uploadBrandingJson($event, '640x88', 'eventBanners', bIndex)
                          " accept="image/*" />
                    <div class="image-specification">
                        <p>
                            <strong>Image Specification</strong>
                        </p>
                        <p>
                            Dimension: (Width x Height) 640x88 pixels;
                            Format:JPG/PNG 72DPI
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full banner-single-wrap">
            <p class="device-name">
                <strong>
                    iPhone 6
                    <span>*</span>
                </strong>
            </p>
            <div class="event-icon-upload custom-branding-banner-wrap">
                <div class="single-banner">
                    <img v-if="data_local['750x103']" :src="data_local['750x103']" />
                    <!-- <span class="img-delete-butn">
                        <button @click="
                              deleteBrandingJson($event, '750x103', 'eventBanners', bIndex)
                            ">
                            <img src="../../assets/images/btn-del.png" />
                        </button>
                    </span> -->
                </div>
                <div class="choose-file-area">
                    <input type="file" @change="
                            uploadBrandingJson($event, '750x103', 'eventBanners', bIndex)
                          " accept="image/*" />
                    <div class="image-specification">
                        <p>
                            <strong>Image Specification</strong>
                        </p>
                        <p>
                            Dimension: (Width x Height) 750x103 pixels;
                            Format:JPG/PNG 72DPI
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full banner-single-wrap">
            <p class="device-name">
                <strong>
                    iPhone 10/11/12
                    <span>*</span>
                </strong>
            </p>
            <div class="event-icon-upload custom-branding-banner-wrap">
                <div class="single-banner">
                    <img v-if="data_local['1125x156']" :src="data_local['1125x156']" />
                    <!-- <span class="img-delete-butn">
                        <button @click="
                              deleteBrandingJson($event, '1125x156', 'eventBanners', bIndex)
                            ">
                            <img src="../../assets/images/btn-del.png" />
                        </button>
                    </span> -->
                </div>
                <div class="choose-file-area">
                    <input type="file" @change="
                            uploadBrandingJson($event, '1125x156', 'eventBanners', bIndex)
                          " accept="image/*" />
                    <div class="image-specification">
                        <p>
                            <strong>Image Specification</strong>
                        </p>
                        <p>
                            Dimension: (Width x Height) 1125x156 pixels;
                            Format:JPG/PNG 72DPI
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full banner-single-wrap">
            <p class="device-name">
                <strong>
                    iPhone 6+
                    <span>*</span>
                </strong>
            </p>
            <div class="event-icon-upload custom-branding-banner-wrap">
                <div class="single-banner">
                    <img v-if="data_local['1242x171']" :src="data_local['1242x171']" />
                    <!-- <span class="img-delete-butn">
                        <button @click="
                              deleteBrandingJson($event, '1242x171', 'eventBanners', bIndex)
                            ">
                            <img src="../../assets/images/btn-del.png" />
                        </button>
                    </span> -->
                </div>
                <div class="choose-file-area">
                    <input type="file" @change="
                            uploadBrandingJson($event, '1242x171', 'eventBanners', bIndex)
                          " accept="image/*" />
                    <div class="image-specification">
                        <p>
                            <strong>Image Specification</strong>
                        </p>
                        <p>
                            Dimension: (Width x Height) 1242x171 pixels;
                            Format:JPG/PNG 72DPI
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col md:w-1-12 w-full banner-single-wrap">
            <p class="device-name">
                <strong>
                    All Android Phone
                    <span>*</span>
                </strong>
            </p>
            <div class="event-icon-upload custom-branding-banner-wrap">
                <div class="single-banner">
                    <img v-if="data_local['1440x176']" :src="data_local['1440x176']" />
                    <!-- <span class="img-delete-butn">
                        <button @click="
                              deleteBrandingJson($event, '1440x176', 'eventBanners', bIndex)
                            ">
                            <img src="../../assets/images/btn-del.png" />
                        </button>
                    </span> -->
                </div>
                <div class="choose-file-area">
                    <input type="file" @change="
                            uploadBrandingJson($event, '1440x176', 'eventBanners', bIndex)
                          " accept="image/*" />
                    <div class="image-specification">
                        <p>
                            <strong>Image Specification</strong>
                        </p>
                        <p>
                            Dimension: (Width x Height) 1440x176 pixels;
                            Format:JPG/PNG 72DPI
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col md:w-1-12 w-full banner-single-wrap">
            <p class="device-name">
                <strong>
                    iPad landscape
                    <span>*</span> / Desktop
                    <span>*</span>
                </strong>
            </p>
            <div class="event-icon-upload custom-branding-banner-wrap">
                <div class="single-banner">
                    <img v-if="data_local['2732x88']" :src="data_local['2732x88']" />
                    <!-- <span class="img-delete-butn">
                        <button @click="
                              deleteBrandingJson($event, '2732x88', 'eventBanners', bIndex)
                            ">
                            <img src="../../assets/images/btn-del.png" />
                        </button>
                    </span> -->
                </div>
                <div class="choose-file-area">
                    <input type="file" @change="
                            uploadBrandingJson($event, '2732x88', 'eventBanners', bIndex)
                          " accept="image/*" />
                    <div class="image-specification">
                        <p>
                            <strong>Image Specification</strong>
                        </p>
                        <p>
                            Dimension: (Width x Height) 2732x88 pixels;
                            Format:JPG/PNG 72DPI
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col md:w-1-12 w-full banner-single-wrap">
            <p class="device-name">
                <strong>
                    iPad Portrait
                    <span>*</span>
                </strong>
            </p>
            <div class="event-icon-upload custom-branding-banner-wrap">
                <div class="single-banner">
                    <img v-if="data_local['2048x88']" :src="data_local['2048x88']" />
                    <!-- <span class="img-delete-butn">
                        <button @click="
                              deleteBrandingJson($event, '2048x88', 'eventBanners', bIndex)
                            ">
                            <img src="../../assets/images/btn-del.png" />
                        </button>
                    </span> -->
                </div>
                <div class="choose-file-area">
                    <input type="file" @change="
                            uploadBrandingJson($event, '2048x88', 'eventBanners', bIndex)
                          " accept="image/*" />
                    <div class="image-specification">
                        <p>
                            <strong>Image Specification</strong>
                        </p>
                        <p>
                            Dimension: (Width x Height) 2048x88 pixels;
                            Format:JPG/PNG 72DPI
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col w-full mt-10 flex flex-wrap items-center justify-center">            
            <vs-button class="mb-2 ml-3" icon="arrow_left" @click="showBannerForm=false;bIndex=null;$emit('showSubmitButton',true);">Back To List</vs-button>
            <vs-button class="mb-2 ml-3" type="border" color="warning" @click="setDefaultBanner">Set Default</vs-button>
            <vs-button class="mb-2 ml-10" @click="saveEventBanner">Save</vs-button>
        </div>
    </div>    
 </div>
</template>

<script>
import vSelect from "vue-select";
import ls from "@/common/localStorage"
export default {
  components: {
    vSelect
  },
  props: {
    BrandingJson: {
      type: Object,
      required: true,
    },
    landingURLOptions: [],    
  },
  data() {
    return {
      data_local: null,
      showBannerForm: false,
      bIndex: null,
      banner: {
            "TargetLink": "NoLink",
            "ExternalLink": "",
            "InternalLink": "",
            "640x88": "",
            "750x103": "",
            "1125x156": "",
            "1242x171": "",
            "1440x176": "",
            "2732x88": "",
            "2048x88": "",
        }
    };
  },
  methods: {
    checkLink(val){
        let bIndex = this.bIndex;
        if(val == 'NoLink'){
            this.data_local.ExternalLink = '';
            this.data_local.InternalLink = '';
        } else if(val == 'External'){
            this.data_local.InternalLink = '';
        } else if(val == 'Interna'){
            this.data_local.ExternalLink = '';
        } else{
            this.data_local.ExternalLink = '';
            this.data_local.InternalLink = '';
        }

    },
    addNewBanner(){   
        this.$emit('showSubmitButton',false);
        this.$vs.loading();              
        this.$store
              .dispatch("eventManagement/getClientsDefaultBrandingJson",
              )
              .then((res) => {                        
                  this.$vs.loading.close();  
                  if(res){
                   this.data_local = res.eventBanners && res.eventBanners.length ? res.eventBanners[0] : res.banner;
                   this.bIndex = this.BrandingJson.eventBanners.length ? this.BrandingJson.eventBanners.length : 0;
                   this.showBannerForm = true;  
                  }else{
                    this.$vs.notify({
                      color: "warning",
                      position: "top-center",
                      text: "Default Branding Not Set!",
                  });
                  }                   
              })
              .catch((err) => {
                  this.$vs.loading.close();
              });
    },
    editBanner(bIndex){
        this.$emit('showSubmitButton',false);
        this.bIndex = bIndex;
        this.data_local = {...this.BrandingJson.eventBanners[this.bIndex]}; 
        this.showBannerForm = true;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    uploadBrandingJson(input, filename, filesrc, bIndex) {
        let vm = this;
        if (input.target.files && input.target.files[0]) {
            let file = input.target.files[0];
            input.target.value = "";
            var metadata = {
                contentType: file.type,
            };

            let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
            if (!validImageTypes.includes(file.type)) {
                alert("Only gif,jpeg & png file allowed.");
                return false;
            }
            let dimension = filename.split("x");
            var _URL = window.URL || window.webkitURL;
            let img = new Image();
            var objectUrl = _URL.createObjectURL(file);
            img.onload = function () {
                if (this.width == dimension[0] && this.height == dimension[1]) {
                    vm.uploadFile(file, filename, filesrc, bIndex);
                } else {
                    alert("File dimension does not match " + filename);
                    return false;
                }
                _URL.revokeObjectURL(objectUrl);
            };
            img.src = objectUrl;
        }
    },
    uploadFile(file, filename, filesrc, bIndex) {
        const reader = new FileReader();
        reader.onload = (e) => {
            //this.BrandingJson[filesrc][bIndex][filename] = e.target.result;
        };
        reader.readAsDataURL(file);
        this.$vs.loading();
        this.$store
            .dispatch("eventManagement/uploadImage", {
                file: file,
                path: `${ls.getSessionEventCollectionName()}/Branding/`
            })
            .then((res) => {
                this.$vs.loading.close();   
                this.data_local[filename] = res;                               
            })
            .catch((err) => {
                this.$vs.loading.close();
            });
    },  
    saveEventBanner(){
        console.log()
        if(this.bIndex >= 0)
            this.BrandingJson.eventBanners[this.bIndex] = this.data_local;
        else
            this.BrandingJson.eventBanners.push(this.data_local);
        this.bIndex = null;
        this.data_local = null;
        this.showBannerForm = false;        
        this.$emit('saveEventBanner');  
        this.$emit('showSubmitButton',true);      
    },
    setDefaultBanner(){
      if(confirm("All saved banner detail will be deleted. Do you want to continue?"))
      {
        this.$vs.loading();              
        this.$store
              .dispatch("eventManagement/getClientsDefaultBrandingJson",
              )
              .then((res) => {                        
                  this.$vs.loading.close();  
                  if(res){
                    this.data_local = res.eventBanners && res.eventBanners.length ? res.eventBanners[0] : res.banner;
                  }else{
                    this.$vs.notify({
                      color: "warning",
                      position: "top-center",
                      text: "Default Branding Not Set!",
                  });
                  }                   
              })
              .catch((err) => {
                  this.$vs.loading.close();
              });
      }
    }, 
  },

};
</script>
